import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Miami needed",
      "Ideal for Palm Beach billionaires on last-minute European trips",
      "Perfect for Worth Avenue shoppers needing passports for Milan",
      "Great for seasonal residents splitting time between continents",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Miami — ~75 miles via I-95",
      "NPIC appointment required before driving to Miami",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Palm Beach County post offices",
      "Good for planned international trips from PBI",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Palm Beach area facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
];

export default function PalmBeachProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Palm Beach"
      headingExtra="FL"
      introText="Palm Beach and barrier island travelers — Worth Avenue shoppers, seasonal residents splitting time between continents, Palm Beach International Airport (PBI) flyers, Mar-a-Lago and Breakers guests, and South Florida executives — have several options for getting a passport fast. Here is how they compare, and why most Palm Beach residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the I-95 drive to Miami."
      options={options}
      emergencyDescription="Palm Beach is a barrier island connected to the mainland by only three bridges — the Royal Park Bridge, the Flagler Memorial Bridge, and the Southern Boulevard Bridge. Florida has only ONE passport agency (Miami) serving 22M+ residents — roughly 75 miles south via I-95. During hurricane season (June–November), bridge closures and I-95 flooding can sever Palm Beach from the mainland entirely. A Category 3+ hurricane makes the bridges impassable and the Miami agency unreachable. Even in good weather, seasonal traffic on I-95 can turn the 75-mile drive into 3+ hours."
      disclaimerText="*Processing speed depends on eligibility and documentation. Palm Beach does not have a regional passport agency — the closest is Miami, roughly 75 miles away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}